const {registerModule} = window;

class SearchlightCta {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.setVars();
    this.bindEvents();
  }

  unmount() {
    document.documentElement.removeAttribute('style');
    this.element.removeEventListener('mousemove', this.onMouseMove.bind(this));
  }

  setVars() {
    this.mouse = {x: 0, y: 0};
    this.clip = this.element.querySelector('[data-ref="clip"]');
    this.link = this.element.querySelector('[data-ref="moment-link"]');
    this.isNewWindow = this.link.getAttribute('target') === '_blank';
    this.spot = this.element.querySelector('[data-ref="spot"]');
    this.transitionNum = 0;
    this.isDesktop = window.matchMedia('(hover: hover)').matches;
  }

  bindEvents() {
    this.element.addEventListener('mousemove', this.onMouseMove.bind(this));
    this.link.addEventListener('click', this.onClick.bind(this));
    this.spot.addEventListener('transitionend', this.onTransitionEnd.bind(this));

    // A page restored from the back/forward cache keeps the unloading state.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        this.reset();
      }
    });
  }

  onTransitionEnd() {
    if (!this.isUnloading) return;

    this.transitionNum++;

    if (this.transitionNum > 1) {
      window.location = this.link.href;
    }
  }

  onMouseMove(e) {
    this.mouse.x = e.pageX - e.currentTarget.offsetLeft;
    this.mouse.y = e.pageY - e.currentTarget.offsetTop;

    if (this.element) {
      document.documentElement.style.setProperty('--pos-x', `calc( ${this.mouse.x}px - var( --clip-size ) )`);
      document.documentElement.style.setProperty('--pos-y', `calc( ${this.mouse.y}px - var( --clip-size ) )`);
    } else {
      document.documentElement.removeAttribute('style');
    }
  }

  onClick(e) {
    if (this.isDesktop && !/^#/.test(this.link.hash) && !this.isNewWindow) {
      e.preventDefault();

      this.isUnloading = true;
      document.body.classList.add('searchlight-unloading');
      this.spot.classList.add('is-unloading');
    }
  }

  reset() {
    this.isUnloading = false;
    this.transitionNum = 0;
    document.body.classList.remove('searchlight-unloading');

    // Disable the transition so the restored page doesn't visibly shrink the spot.
    this.spot.style.transition = 'none';
    this.spot.classList.remove('is-unloading');
    void this.spot.offsetWidth;
    this.spot.style.transition = '';
  }
}

registerModule('SearchlightCta', SearchlightCta);
